<template>
    <section id="printPage">
        <div class="header">
            <div>
                <img src="../assets/logo.svg" alt="logo">
            </div>
            <div>
                <p>
                    <span>You got the idea,</span>
                    <span>my job is making it reallity.</span>
                </p>
            </div>
        </div>

        <div class="body">
            <div class="details">
                <p class="date">{{ comp_Invoice.date }}</p>

                <h1>Pricing invoice</h1>

                <div class="to">
                    <p class="requester" ref="req">
                        <span>Requested by:</span> 
                        <input 
                            @input="catchInput('requester')" 
                            v-model="comp_Invoice.requester" 
                            :disabled="Details != undefined" 
                            type="text" 
                            placeholder="Your name..."
                        ></p>
                    <p class="receiver" v-if="!validating || (validating && comp_Invoice.company)" ref="comp">
                        <span>From:</span> 
                        <input 
                            @input="catchInput('receiver')" 
                            v-model="comp_Invoice.company" 
                            :disabled="Details != undefined" 
                            type="text" 
                            placeholder="(optional) Company name..."
                        ></p>
                    <p class="receiver">
                        <span>Invoice #:</span> 
                        <input 
                            v-model="comp_Invoice.invoice" 
                            type="text" 
                            disabled 
                            placeholder="Generated when printing." 
                        ></p>
                </div>

                <div class="invoice_detail" v-if="!validating || (validating && comp_Invoice.description)">
                    <h2>General description</h2>
                    <textarea
                        v-model="comp_Invoice.description"
                        :disabled="Details != undefined"
                        @input="adjustHeight($event)"
                        maxlength="350"
                        placeholder="(optional) Write a short description of what you are requesting. NOTE: The description will be ignored if does not have more than 49 characters."
                    >
                    </textarea>
                </div>
            </div>

            <div class="breakdown">
                <h2>Breakdown</h2>
                <PricingTable :Tasks="comp_Invoice.tasks" />
            </div>
        </div>

        <div class="footer">
            <div>
                <p>This document was auto generated, you can make sure it is authentic by visiting: <span>{{ "https://showroom.nethanzel.dev/pricing"  }}</span>,
                or by scanning the related bar code.</p>

                <p>Any issue? Write an email to <span>{{ "nethanzels.projects@outlook.com" }}</span></p>
            </div>
            <div>
                <img src="../assets/qr-placeholder.png" alt="generated_qr" id="qr_place">
            </div>
        </div>
    </section>
</template>

<script>
    import PricingTable from './PricingTable.vue';
    import { EventBus } from "../mixins/eventBus.js";
    export default {
        components: {
            PricingTable
        },
        props: {
            Details: Object
        },
        methods: {
            adjustHeight(el) {
                el.target.style.height = "1px";
                el.target.style.height = (el.target.scrollHeight + 1) + "px";
                EventBus.$emit("pageDescription", this.comp_Invoice.description);
            },
            invoiceDate() {
                if(this.Details) {
                    return new Date(this.Details.date).toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"});
                }
                return new Date().toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"})
            },
            catchInput(source) {
                if(source == 'requester') {
                    EventBus.$emit("inpRequester", this.comp_Invoice.requester);
                }

                if(source == 'receiver') {
                    EventBus.$emit("inpReceiver", this.comp_Invoice.company);
                }
            }
        },
        data() {
            return {
                comp_Invoice: {
                    date: null,
                    requester: "",
                    company: "",
                    tasks: [],
                    invoice: "",
                    description: ""
                },
                validating: false
            }
        },
        mounted() {
            this.comp_Invoice.date = this.invoiceDate();
            if(this.$route.params.invoice) {
                this.validating = true;
                this.comp_Invoice.requester = this.Details.requester;
                this.comp_Invoice.company = this.Details.company;
                this.comp_Invoice.invoice = this.Details.invoice;
                this.comp_Invoice.description = this.Details.desc;
                this.comp_Invoice.tasks = this.Details.tasks;
            }

            EventBus.$on("stopValidation", () => {
                this.comp_Invoice = {
                    date: null,
                    requester: null,
                    company: null,
                    tasks: [],
                    invoice: null,
                    description: null
                };
                this.validating = false;
            });

            EventBus.$on("invalidRequester", () => {
                this.$refs.req.style.backgroundColor = "#ff000075";
                setTimeout(() => this.$refs.req.style.backgroundColor = "transparent", 5000);
            });
        }
    }
</script>

<style scoped lang="scss">
    #printPage {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        
        min-width: 793px;
        max-width: 793px;

        min-height: 1124px;
        max-height: 1124px;

        margin: 35px 25px;

        padding: 25px 30px;

        user-select: none;
    }
    
    .header {
        display: flex;
        height: 70px;
        margin: 30px 0 40px 0;
        
        div img {
            width: 180px;
        }

        div p span {
            display: block;
            text-align: left;
        }

        div:first-child {
            width: 50%;
            height: 100%;
            display: flex;
            justify-content: end;
            padding: 0 15px 0 0;
            border-right: 1.5px solid black;

        }

        div:nth-child(2) {
            width: 50%;
            height: 100%;
            display: flex;
            align-items: center;
            padding: 0 0 0 15px;
            border-left: 1.5px solid black;

        }
    }

    .body {
        display: flex;
        flex-direction: column;
        width: 100%;
        min-height: 860px;
        .details {
            max-height: 345px;
            h2 {
                margin: 10px 0 5px 0;
            }
            .date {
                text-align: right;
                font-size: 12px;
            }
            .to {
                text-align: left;
                margin: 25px 0 5px 0;
                p {
                    margin: 5px 0;
                }
                span {
                    font-weight: bold;
                }

                input {
                    background-color: transparent;
                    border: 0;
                    outline: none;
                    color: #000;
                    margin: 0 0 0 10px;
                    min-width: 550px;
                }
            }
            .invoice_detail {
                margin: 20px 0 15px 0;
                p {
                    font-size: 19px;
                    font-weight: bold;
                    margin-bottom: 7px;
                }
                textarea {
                    background-color: transparent;
                    border: 0;
                    width: 95%;
                    outline: none;
                    resize: none;
                    color: #3e3e3e;

                    height: auto;
                    max-height: 80px;
                }
            }
        }

        .breakdown {
            width: 100%;
            max-height: 480px;
            height: 480px;
        }
    }

    .footer {
        display: flex;
        flex-direction: row-reverse;
        max-height: 150px;
        overflow: hidden;
        margin-top: 15px;
        padding: 0 60px 0 60px;


        div {
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        div:nth-child(1) {
            width: 75%;
            padding: 0 0 0 20px;
            p {
                text-align: left;
                margin: 7px 0;
                font-size: 12px;
                line-height: 18px;
                span {
                    text-decoration: underline;
                }
            }
        }

        div:nth-child(2) {
            display: flex;
            align-items: center;
            width: 25%;
            img {
                max-width: 100px;
                max-height: 100px;
            }
        }
    }

    @media screen and (max-width: 940px) {
        #printPage {
            transform: scale(0.95);
        }
    }

    @media screen and (max-width: 875px) {
        #printPage {
            transform: scale(0.85);
        }
    }

    @media screen and (max-width: 600px) {
        #printPage {
            transform: scale(0.75);
        }
    }

    @media screen and (max-width: 550px) {
        #printPage {
            transform: scale(0.65);
        }
    }

    @media screen and (max-width: 450px) {
        #printPage {
            transform: scale(0.5);
        }
    }
</style>